import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatDistanceToNow } from 'date-fns';

// Firebase
import { db } from '../../../../config/firebase-config';
import { collection, getDocs, getDoc, doc, query, where } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

// Libraries - imported
import moment from 'moment';

// Actions

// components - imported
import { Avatar, Button } from '@material-ui/core';
import ImageBlock from '../../../common/ImageBlock';
import DefaultAvatar from 'react-avatar';
import Verification_Badge from '../../../common/Verification_Badge';
import Spinner from '../../../common/Spinner';

// DraftJS
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const Post_Message = ({ 
    message: { 
        _id, 
        user, 
        text, 
        date,
        likes,
        postId
    },
    chat: {
        chat
    },
    auth,
    chatData,
    otherChatUserId,
    scrollToBottom
}) => {

    // --- Convert DraftJS text to HTML text

    // Tracks whether the text has been converted
    const [gotText, setGotText] = useState(false);
    // Stores the converted text
    const [textState, setTextState] = useState(null);
    const [rawTextState, setRawTextState] = useState(null);

    // --- END: Convert DraftJS text to HTML text

    // --- Get Media data ---

    // Check if post has image - for font size reasons
    const [hasImg, setHasImg] = useState(false);
    // Flag for checking if hasImg is properly updated
    const [checkHasImg, setCheckHasImg] = useState(false);
    const [imgHeight, setImgHeight] = useState(200);

    // --- END: Get Media data ---

    // --- Get Post data ---

    const [postData, setPostData] = useState(null);
    const [gotPost, setGotPost] = useState(false);

    // --- END: Get Post data ---

    // --- Read receipt stuff ---

    const [lastMessageID, setLastMessageID] = useState(null);
    const [lastMessage, setLastMessage] = useState(null);
    const [notRead, setNotRead] = useState(true);

    // --- END: Read receipt stuff ---

    // --- Message Btns stuff ---

    // Tracks the like status of post
    const [liked, setLiked] = useState(false);
    // Flag for checking if like is properly updated
    const [checkLike, setCheckLike] = useState(false);

    // --- END: Message Btns stuff ---

    // -- Text Truncation Functions ---
    
    // is text expanded?
    const [isExpanded, setIsExpanded] = useState(false);
    const CHARACTER_LIMIT = 200;
    const [shouldTruncate, setShouldTruncate] = useState(false);

    // -- END: Text Truncation Functions ---

    useEffect(() => {
        //( Get Post Data
        if(postId) getPostData(postId);

    }, [])

    useEffect(() => {
        
        // Scroll to the bottom of messages when a new post is loaded
        scrollToBottom();

    }, [postData])

    // Handle Read Reciept
    useEffect(() => {
    
            if(chat) {
                if(chat.last_message_id) setLastMessageID(chat.last_message_id)
                setLastMessage(chat.last_message);
    
                setNotRead(true);
    
                if(Array.isArray(chat.read)) {
                    if(!chat.read.includes(otherChatUserId)) {
                        setNotRead(false);
                    }
                } else {
                    if(Array.isArray(chatData?.read) && !chatData?.read.includes(otherChatUserId)) {
                        setNotRead(false);
                    }
                }
            }
    
            
    
        }, [chat])

    // --- Message Btn Actions ----

    // Checks if the user has already liked the message
    if(auth.user && !checkLike) {
        if(likes?.length > 0){
            setLiked(true);
        }
        
        // Marks that the check for likes has been performed
        setCheckLike(true);
    }  

    // --- END: Message Btn Actions ---

    // --- Sent By Current User ---

    // Initial state set-up for checking if the message is sent by the current user
    let isSentByCurrentUser = false;

    // Set 'true' if the user_name matches the current user's name
    if(user === auth.user._id) {
        isSentByCurrentUser = true;
    }

    // --- END: Sent By Current User ---

    const detect_Links_phoneNumbers_Addresses =(string) => {
        // Regex to match URLs
        const urlRegex = /(?<![@\w])(?:https?:\/\/|www\.)?(?:[a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s<]*)?(?![\w@])/gi;
        
        // Regex for phone numbers (basic US-style, adjust if needed)
        // Matches formats like: 123-456-7890, (123) 456-7890, 1234567890, +1 123 456 7890
        const phoneRegex = /(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?){1,2}\d{4}/g;

        // Regex for addresses (US-style)
        // Matches things like: 123 Main St | 456 Elm Street, Springfield | 789 Broadway Ave, Apt 5, New York
        // TODO: Use a location keyword list to improve detection (i.e. city names, states, countries)
        const addressRegex = /\d{1,5}\s[\w\s]{1,30}\s(?:Street|St|Avenue|Ave|Boulevard|Blvd|Road|Rd|Lane|Ln|Drive|Dr|Court|Ct|Way|Wy|Plaza|Circle|Ct|Terrace|Ter|Trail|Trl)\b(?:,\s?[\w\s]+)*/gi;

        // 1st wrap URLs with <a> tags
        let temp_result = string.replace(urlRegex, (url) => {

            // If the URL already starts with http:// or https://, leave it
            // Otherwise, prepend http://
            // (purpose: makes sure the link redirects properly)
            const safe_url = /^(https?:\/\/)/i.test(url) ? url : `http://${url}`;

            return `<a href="${safe_url}" class='hoverable_link' target="_blank" rel="noopener noreferrer">${url}</a>`;
        });

        // 2nd replace phone numbers
        temp_result = temp_result.replace(phoneRegex, (phone) => {
            // Remove spaces/dashes for href
            const tel = phone.replace(/[-.\s()]/g, "");
            return `<a href="sms:${tel}" class='hoverable_link'>${phone}</a>`;
        });

        // 3rd replace addresses with Google Maps links
        temp_result = temp_result.replace(addressRegex, (address) => {
            const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
            return `<a href="${href}" class='hoverable_link' target="_blank" rel="noopener noreferrer">${address}</a>`;
        });

        return temp_result;
    }

    // -- Text Truncation Functions ---
    
    // Helper function
    const getPlainText = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    // -- END: Text Truncation Functions ---

    // Get Post Data
    const getPostData = async (id) => {
        // Create a reference to the specified post document in the "posts" collection
        const docRef = doc(db, 'posts', id)
        
        // Retrieve the document with the specified ID from the "posts" collection
        const postDoc = await getDoc(docRef);
    
        if(postDoc.data()) {
            setPostData({
                ...postDoc.data(),
                _id: id
            })
        } else {
            setPostData(null);
        }

        setGotPost(true);
    }

    // Converts the DraftJS text to HTML and sets the converted text
    useEffect(() => {
        if (postData && !gotText) {
            let unRawState;
            let unRawDescription;

            if(postData.text) {
                try {
                    // Convert stringified DraftJS JSON to a raw JS object
                    const rawBlocksData = JSON.parse(postData.text);

                    // Extract just the array of text blocks
                    if (rawBlocksData && Array.isArray(rawBlocksData.blocks)) {
                        unRawState = EditorState.createWithContent(
                            convertFromRaw(rawBlocksData)
                        );

                        unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));
                    } else {
                        unRawDescription = postData.text;
                    }

                    // -- Detect URLs & Phone #'s in text ---

                    unRawDescription = detect_Links_phoneNumbers_Addresses(unRawDescription);
                    
                    // -- END: Detect URLs & Phone #'s in text ---

                    // -- Text Truncation Functions ---

                    // Check if truncation is needed
                    const plainText = getPlainText(unRawDescription);
                    const shouldTruncate_temp = plainText.length > CHARACTER_LIMIT;
                    const truncated_text = plainText.substring(0, CHARACTER_LIMIT) + '...';
                    setShouldTruncate(shouldTruncate_temp);

                    // -- END: Text Truncation Functions ---

                    setRawTextState(unRawDescription);

                    setTextState(detect_Links_phoneNumbers_Addresses(truncated_text));
                } catch (error) {
                    const text_final = detect_Links_phoneNumbers_Addresses(postData.text);
                    
                    setRawTextState(text_final);
                    setTextState(text_final);
                }
            }
            
            // Marks that the text conversion has been performed
            setGotText(true);
        }
    }, [postData, gotText]);

    let optimized_profile_img_path;

    if(postData?.user.img) {

        // --- ImageKit (img optimization service) ---
   
        // Replace the firebase URL with ImageKit.io URL-endpoint
        optimized_profile_img_path = postData.user.img.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
    }

    // Read status comparison
    let showReadReceipt = false;

    if(lastMessageID) {
        if(lastMessageID === _id) {
            showReadReceipt = true
        }
    } else if(lastMessage === text) {
        showReadReceipt = true;
    }

    let content = <Spinner />;

    if (gotPost) {
        if (postData) {
            content = (
                <Fragment>
                    <div style={{display: 'flex', alignItems: 'center', paddingBottom: '8px'}}>
                        <div className="post__avatar in_chatBox" onClick={() => window.location.href = `/user/${postData.user._id}`}>
                            {postData.user.img ? (
                                <Avatar src={optimized_profile_img_path && optimized_profile_img_path} />
                            ) : (
                                <DefaultAvatar name={`${postData.user.first_name} ${postData.user.last_name}`} />
                            )}
                        </div>
                        <div style={{lineHeight: '15px'}}>
                            <p style={{color: 'rgb(15, 20, 25)', marginLeft: '5px', fontSize: '15px'}}>{postData.username && postData.username + ' '}</p>
                            {/* Post Timestamp */}
                            <span style={{margin: '0 3px 0 5px'}} className="post__headerSpecial">
                                {formatDistanceToNow(postData.date)} ago
                            </span>
                        </div>
                    </div>
                    {textState !== null && (
                        <Fragment>
                            {!isExpanded && shouldTruncate 
                                    ? <div className='post_message_text' dangerouslySetInnerHTML={{__html: textState}} /> 
                                    : <div className='post_message_text' dangerouslySetInnerHTML={{__html: rawTextState}} />}

                            {shouldTruncate && (
                                <span 
                                    onClick={() => setIsExpanded(!isExpanded)}
                                    className='post_see_more_btn'
                                >
                                    {isExpanded ? 'See less' : 'See more'}
                                </span>
                            )}
                        </Fragment>
                        
                    )}
                    <div style={{position: 'relative'}}>
                        {/* Post Images */}
                        <ImageBlock detailPost={postData} setHasImg={setHasImg} setCheckHasImg={setCheckHasImg} checkHasImg={checkHasImg} redirect_on_click in_chatBox setImgHeight={setImgHeight} />
                    </div>
                </Fragment>
            )
        } else {
            content = (
                <p style={{fontStyle: 'italic', color: "#000"}}>* Post deleted **</p>
            )
        }
    }
    
    return (
        <div onClick={postData ? () => window.location.href = `/post/${postData._id}` : null} style={{cursor: 'pointer'}} className={`messageContainer ${isSentByCurrentUser ? 'currentUser' : ''}`}>

            <div className="messageBox__container in_chatBox">
                {/* Msg*/}
                <div style={{background: 'rgb(239,239,239)'}} className="messageBox">
                    {content}
                </div>

                {/* Msg timestamp */}
                <div className="messageBox__specialText">
                    <p>{moment(date).format('dddd')}{' '}{moment(date).format("h:mm a")}</p>

                    {showReadReceipt && (
                        (notRead) ? (
                            <p style={{marginLeft: '5px'}}>&#8226; <span style={{fontWeight:700}}>Delivered</span></p>
                        ) : (
                            <p style={{marginLeft: '5px'}}>&#8226; <span style={{fontWeight:700}}>Seen</span></p>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

Post_Message.propTypes = {
    chat: PropTypes.object.isRequired, // Required prop: Function to get user by ID
    auth: PropTypes.object.isRequired, // Required prop: Object representing the authenticated user
}

const mapStateToProps = state => ({
    // Mapping the auth state from the Redux store to the 'auth' prop
    auth: state.auth,
    chat: state.chat,
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
})(Post_Message);